import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { layout } from '../styles';
var enteredStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\topacity: 1;\n\ttransform: translateX(0px);\n"])));
var exitingStyles = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\topacity: 0;\n\ttransition-duration: 200ms;\n"])));
function getAnimationForState(animationState) {
  if (animationState === 'entered') {
    return enteredStyles;
  }
  if (animationState === 'exiting') {
    return exitingStyles;
  }
  return null;
}
export var StyledNotification = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tmargin-bottom: ", ";\n\ttransition: opacity 250ms ease-in-out, transform 250ms ease-in-out;\n\topacity: 0;\n\tpointer-events: auto;\n\ttransform: translateX(-500px);\n\t", "\n"])), layout.smallSpace, function (props) {
  return getAnimationForState(props.animationState);
});